<script>
  import { onMount } from "svelte";
  import StaticArtwork from "./StaticArtwork.svelte";
  import { createRandomCleanEncoding } from "bitframes";

  export let system = 0x01;

  let encoding;
  next();

  onMount(() => {
    const interval = setInterval(() => {
      next();
    }, 1500);
    return () => {
      clearInterval(interval);
    };
  });

  function next() {
    encoding = createRandomCleanEncoding(undefined, { system });
  }
</script>

<StaticArtwork {encoding} displayPadding={0}></StaticArtwork>
